<div class="payment-params-container">
    <div class="cnt-row-centered" style="justify-content: space-between">
        <div [ngClass]="{
             'light-orange-rectangle': !isBuyPlanSlot && !isBusinessDoctors,
             'light-orange-rectangle-upgrade': isBuyPlanSlot && !isBusinessDoctors,
             'business-doctors-rectangle' : !isBuyPlanSlot && isBusinessDoctors,
             'business-doctors-rectangle-upgrade' : isBuyPlanSlot && isBusinessDoctors
             }">
            <span style="font-size: 14px; font-weight: 600;"
                  [translate]="isBuyPlanSlot ? 'upgrade' : 'BIG_SUBSCRIPTION'">
            </span>
        </div>
    </div>

    <div [width]="60"></div>

    <div *ngIf="initialSubscriptionType != 'Annually'" class="switch-container">
        <span class="label">{{ 'Monthly' | translate }}</span>
        <label class="switch"
               data-testid="BillingFrequencySwitcher"
               attr.data-frequency="{{ currentFrequency }}">
            <input type="checkbox"
                   [(ngModel)]="licensePlanId"
                   (change)="selectFrequency($event)" />
            <span class="slider"></span>
        </label>
        <span class="label">{{ 'Annually' | translate }}</span>
    </div>
    <div *ngIf="initialSubscriptionType == 'Annually'" [width]="38"></div>

    <div style="width: 75px;">
        <div *ngIf="licensePlanId === 1"
             [ngClass]="{
                'light-orange-circle' : !isBusinessDoctors,
                'business-doctors-circle' : isBusinessDoctors
             }"
             style="width: 75px; height: 34px;">
            <span style="font-size: 14px; font-weight: 600"
                  data-testid="Save20Percents">{{ 'SAVE_20_PERCENT' | translate }}</span>
        </div>
    </div>

    <ng-container *ngIf="!isBuyPlanSlot; else emptyWidth">
        <div class="cnt-column-centered">
            <combo #currencySymbolCombo
                   [showImg]="false"
                   name="currencySymbol"
                   [ComboData]="currencySymbols"
                   [(ngModel)]="currentCurrencyId"
                   [height]="34"
                   [width]="85"
                   label=""
                   backgroundColor="white"
                   textClass="small-field"
                   inputTextClass="p2Font b1Color"
                   [testId]="'CurrencyCombo'"
                   (changeCaller)="selectCurrency()"
                   [currencyCombo]="true"
                   [isTextCentered]="true"
                   [triggerWidth]="10">
            </combo>
        </div>
    </ng-container>
    <ng-template #emptyWidth>
        <div [width]="70"></div>
    </ng-template>
</div>

<div class="cnt-column" style="padding: 0 50px 0 50px">
    <div style="display: flex; flex-direction: row; align-items: center">
        <span style="font-size: 48px; padding-right: 12px; font-weight: 700"
              data-testid="SubscriptionPrice">{{ currentCurSymbol }}{{ currentPriceSingle }}</span>
        <span style="font-size: 18px; padding-right: 5px;">
            {{ 'SLASH_MONTH_BILLED' | translate }}
            <span [translate]="initialSubscriptionType === 'Monthly' ? 'MONTHLY' : 'ANNUALLY'"></span>
            {{ 'AT' | translate }}
        </span>
        <span style="font-size: 18px; font-weight: 600"
              data-testid="SubscriptionTotalPrice">{{ currentCurSymbol }}{{ getBilledPrice() }}</span>
    </div>

    <div [height]="20"></div>

    <div style="display: flex; align-items: center">
        <div class="success-logo-container" style="margin-right: 10px"></div>
        <span style="font-size: 18px">{{ 'ALL_FEATURES' | translate }}</span>
    </div>

    <div [height]="15"></div>

    <div style="display: flex; align-items: center">
        <div class="success-logo-container" style="margin-right: 10px"></div>
        <span style="font-size: 18px">
            {{ singlePlansCount }}
            <span [translate]="singlePlansCount === '1' ? 'Plan' : 'Plans'"></span>
        </span>
    </div>

    <div [height]="15"></div>

    <div class="cnt-row-centered" style="justify-content: space-between">
        <div style="display: flex; align-items: center">
            <div class="success-logo-container" style="margin-right: 10px"></div>
            <span style="font-size: 18px">{{ 'CUSTOMER_SUPPORT' | translate }}</span>
        </div>

        <div class="cnt-row-centered">
            <span class="extra-plans-text">{{ 'ADD_EXTRA_PLANS_FOR' | translate }}</span>
            <div [ngClass]="{
                    'light-orange-circle' : !isBusinessDoctors,
                    'business-doctors-circle' : isBusinessDoctors
                 }">
                <span style="font-size: 16px; font-weight: 400">+{{ currentCurSymbol }}{{ currentExtraPlansPrice }}</span>
            </div>
        </div>
    </div>

    <custom-slider (plansCountChange)="changeSinglePlansCount($event)"
                   [brixxSinglePlansCountItems]="brixxSinglePlansAvailableCountItems"
                   [initialPlanCount]="initialPlanCount"
                   [testId]="'Plans'">
    </custom-slider>

    <div [height]="10"></div>

    <div style="display: flex; align-items: center; margin-bottom: 5px;">
        <span style="font-size: 16px; margin-left: 5px">
            {{ singlePlansCount }}
            <span [translate]="singlePlansCount === '1' ? 'Plan' : 'Plans'"></span>
        </span>
    </div>
</div>

<div class="cnt-column-centered">
    <div class="buttonContainer-brixx">
        <ng-container *ngIf="isBuyPlanSlot && planCountIsEqual(); else notCurrentPlan">
            <div class="cnt-column-centered">
                <div class="current-plan-btn">
                    <span style="font-size: 18px; font-weight: 600; color: #c0c3c8" i18n>{{ 'CURRENT_PLAN' | translate }}</span>
                </div>
            </div>
        </ng-container>
        <ng-template #notCurrentPlan>
            <simple-btn [width]="270"
                        [backgroundFillCls]="'o2Background'"
                        [hoverFillCls]="'o1Background'"
                        [boxShadowCls]="'primary-shadow'"
                        [leftImgCls]="!isBuyPlanSlot ? 'subscribe-icon' : ''"
                        [text]="getSubscribeBtnText() | translate"
                        i18n-text
                        data-testid="SubscribeBtn"
                        [textCls]="'subscribe-btn-text'"
                        [height]="50"
                        (click)="openPayment(licensePackageType.BrixxSingle)"
                        [cornerRadius]="50"
                        [horizontalPadding]="20">
            </simple-btn>
            <span *ngIf="getSubscribeBtnText() == 'UPGRADE'" class="price-tax-text">{{ 'POINT_PRICE_EXCLUDES_LOCAL' | translate }}</span>
        </ng-template>
    </div>

    <div class="brixx-pan-separator"></div>
</div>
